import { render, staticRenderFns } from "./VolverButton.vue?vue&type=template&id=492b5ebe&scoped=true&"
import script from "./VolverButton.vue?vue&type=script&lang=ts&"
export * from "./VolverButton.vue?vue&type=script&lang=ts&"
import style0 from "./VolverButton.vue?vue&type=style&index=0&id=492b5ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492b5ebe",
  null
  
)

export default component.exports